<template lang="html">
  <div :class="{'input': 1, 'is-sneaky': sneaky}">
    <div class="input-wrapper">
      <slot></slot>
    </div>

    <input-footer :error="error" :helper-text="helperText" :count="count" :limit="limit" />
  </div>
</template>

<script>
  import InputFooter from '../../../components/ui/inputs/InputFooter.vue'

  export default {
    props: ['error', 'helperText', 'classList', 'count', 'limit', 'sneaky', 'disabled'],

    components: {
      InputFooter
    }
  }
</script>

<style lang="sass">
  @import '../../../styles/base/variables'
  @import '../../../styles/helpers/mixins'

  .input
    width: 100%
    position: relative

    &.has-focus
      .input-wrapper
        &:after
          background: $color-primary!important

    &.is-invalid
      .validation-error
        // TODO: lose the important
        color: $color-error!important

      .helper-text
        color: $color-text

      .input-wrapper
        &:after
          background: $color-error!important

    &.disabled
      .input-wrapper
        &:after
          background: $color-grey-lighter !important

    &.is-sneaky
      >.input-wrapper
        &:after
          display: none

    .input-wrapper
      position: relative
      display: flex
      padding-top: 20px

      // the underline
      &:after
        width: 100%
        height: 2px
        position: absolute
        display: inline-block
        content: ''
        transition: background-color $transition-duration $transition-easing
        bottom: 0
        left: 0
        background: $color-grey-dark
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/inputs/InputWrapper.vue